import React from 'react';
import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm, IOtherTravellers } from '../../../../types';
import { boolToYesNo } from '../../../../utilities/formatting';
import { relationshipLabel } from '../../../pages/visa/other-travellers/qPage1/utils';
import { parseDate, formatDate } from 'shared-components';
import { SummaryGroup } from '../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';

function VisaPrepOtherTravellersInfo(props: IVisaPrepForm) {
  const renderOtherTravellers = () => {
    const allOtherTravellers: React.ReactNode[] = [];
    if (props.otherTravellers && props.otherTravellers.length) {
      props.otherTravellers.forEach((traveller: IOtherTravellers, i: number) => {
        allOtherTravellers.push(
          <SummaryGroup title={`Traveller ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={VQ.RELATIONSHIP_TO_YOU}
              label="What is this person's relationship to you?"
              value={traveller.relationship ? relationshipLabel(traveller.relationship) : undefined}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.RELATIONSHIP_TO_YOU_OTHER}`}
              value={traveller.relationshipOther}
              label="Other relationship"
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.ADULT_OR_CHILD}
              label="Are they an adult or child?"
              value={String(traveller.adultOrChild).toLowerCase()}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.NATIONALITY}-${i}`}
              value={traveller.nationality}
              label="Nationality"
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.SAME_NATIONALITY}
              label="Have they always had the same nationality?"
              value={boolToYesNo(traveller.sameNationality)}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.FAMILY_NAME}`}
              value={traveller.familyName}
              label="Family Name"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.GIVEN_NAME}`}
              value={traveller.givenName}
              label="Given Name"
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.DOB}
              label="Date of Birth"
              value={traveller.dob ? formatDate(parseDate(traveller.dob), 'DD/MM/YYYY') : ''}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.HAS_UK_VISA}
              label="Do they have a visa for the UK?"
              value={boolToYesNo(traveller.ukVisa)}
            />
            <SummaryRow
              className={'visa-summary'}
              key={VQ.HAS_PASSPORT}
              label="Do they have a Passport or Travel Document?"
              value={boolToYesNo(traveller.hasPassport)}
            />
            {traveller.hasPassport ? (
              <SummaryRow
                className={'visa-summary'}
                key={VQ.PASSPORT_NUMBER}
                value={traveller.passportNumber}
                label="Current Passport or Travel Document Number:"
              />
            ) : null}
          </SummaryGroup>,
        );
      });
    }
    return allOtherTravellers;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.TRAVELLING_WITH_OTHERS}
        label={'Travelling with others'}
        fullLabel={`Will you be travelling to the UK with anyone you have not mentioned in the previous sections?`}
        value={boolToYesNo(props.travellingWithOthers)}
      />
      {props.travellingWithOthers ? (
        <>
          <SummaryRow className={'visa-summary'} label="How many?" value={props.otherTravellers?.length} />
          <Box as="ol" pl={8} key={'Other travellers'}>
            {renderOtherTravellers()}
          </Box>
        </>
      ) : null}
    </>
  );
}

export default VisaPrepOtherTravellersInfo;
